import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { disciplineAPI } from '../../services/api';
import { getErrorMessage } from '../../utils/errorHandler';

export const fetchRecords = createAsyncThunk('discipline/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await disciplineAPI.fetchRecords(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch discipline records'));
  }
});

export const createRecord = createAsyncThunk('discipline/create', async (data, { rejectWithValue }) => {
  try {
    const response = await disciplineAPI.createRecord(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create record'));
  }
});

export const updateRecord = createAsyncThunk('discipline/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await disciplineAPI.updateRecord(id, data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to update record'));
  }
});

export const resolveRecord = createAsyncThunk('discipline/resolve', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await disciplineAPI.resolveRecord(id, data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to resolve record'));
  }
});

const initialState = {
  records: [],
  currentRecord: null,
  stats: null,
  loading: false,
  error: null,
};

const disciplineSlice = createSlice({
  name: 'discipline',
  initialState,
  reducers: {
    clearDisciplineError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecords.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchRecords.fulfilled, (state, action) => { state.loading = false; state.records = action.payload.data || action.payload; })
      .addCase(fetchRecords.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createRecord.fulfilled, (state, action) => { state.records.unshift(action.payload); })
      .addCase(updateRecord.fulfilled, (state, action) => { state.records = state.records.map((r) => r.id === action.payload.id ? action.payload : r); state.currentRecord = action.payload; })
      .addCase(resolveRecord.fulfilled, (state, action) => { state.records = state.records.map((r) => r.id === action.payload.id ? action.payload : r); state.currentRecord = action.payload; });
  },
});

export const { clearDisciplineError } = disciplineSlice.actions;
export default disciplineSlice.reducer;
